import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate } from "react-router-dom";
import { get, post } from "src/utils/networkUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function MinigamesContestsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState(null);
  const [openStageDialog, setOpenStageDialog] = useState(false);
  const [newConestTitle, setNewConestTitle] = useState("");
  const { isViewer } = getUserPermissions();

  useEffect(() => {
    get(`/admin/minigames/contests`).then(function (response) {
      setRows(response.contests);
    });
  }, []);

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const handleCreateContest = () => {
    setOpenStageDialog(false);
    setLoading(true);
    post(`/admin/minigames/contests`, {
      title: newConestTitle,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const handleOpenEditStageDialog = (stageId) => {
    const stage = rows.find((item) => item.stageId === stageId);
    console.log(stage, stageId);
    if (stage) {
      setOpenStageDialog(true);
      setOpen(null);
      setOpenId(null);
    }
  };

  return (
    <>
      <Helmet>
        <title> Mini Games Contests </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Mini Games Contests
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenStageDialog(true)}
          >
            Create Contest
          </Button>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Contest ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.contestId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.title}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.startDate}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.statusType === 0 ? "Draft" : "Active"}
                        </TableCell>
                        {!isViewer && (
                          <TableCell align="right">
                            <Button
                              variant="outlined"
                              startIcon={<Iconify icon="eva:edit-outline" />}
                              onClick={() =>
                                navigate(
                                  `/dashboard/minigames/contest/edit?contest_id=${row.contestId}`
                                )
                              }
                            >
                              Edit
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        {!isViewer && (
          <MenuItem onClick={() => handleOpenEditStageDialog(openId)}>
            <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
            Edit
          </MenuItem>
        )}

        <MenuItem
          onClick={() =>
            navigate(`/dashboard/stage/leaderboard?stage_id=${openId}`)
          }
        >
          <Iconify icon={"eva:list-outline"} sx={{ mr: 2 }} />
          Leaderboard
        </MenuItem>
      </Popover>

      {openStageDialog && (
        <Dialog
          open={true}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Create Contest</DialogTitle>
          <DialogContent>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  id="title"
                  label="Title"
                  fullWidth
                  value={newConestTitle}
                  variant="standard"
                  onChange={(e) => setNewConestTitle(e.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenStageDialog(false)}>Cancel</Button>
            <Button
              onClick={() => handleCreateContest()}
              autoFocus
              disabled={false}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
